import { render, staticRenderFns } from "./LandingPagesBrandView.vue?vue&type=template&id=4877f313&scoped=true"
import script from "./LandingPagesBrandView.vue?vue&type=script&lang=js"
export * from "./LandingPagesBrandView.vue?vue&type=script&lang=js"
import style0 from "./LandingPagesBrandView.vue?vue&type=style&index=0&id=4877f313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877f313",
  null
  
)

export default component.exports